module.exports = __webpack_public_path__ + "media/images/button-minus-c3e17ce33ce9bc1cf49360c4f9159718.png";